/**
 * AWS Amplify configuration for Cognito authentication.
 * 
 * Amplify v6 configuration format.
 * 
 * Reference: https://docs.amplify.aws/react/build-a-backend/auth/connect-your-frontend/authenticate-users/
 */

import { Amplify } from 'aws-amplify';
import { config } from './env';

/**
 * Configure AWS Amplify with Cognito User Pool settings.
 * 
 * This must be called before using any Amplify authentication features.
 * 
 * Amplify v6 uses a different configuration format than v5.
 * The configuration must match the exact structure expected by Amplify v6.
 */
export function configureAmplify(): void {
  console.log('🔧 Configuring Amplify with:', {
    userPoolId: config.cognitoUserPoolId ? `${config.cognitoUserPoolId.substring(0, 10)}...` : 'MISSING',
    userPoolClientId: config.cognitoClientId ? `${config.cognitoClientId.substring(0, 10)}...` : 'MISSING',
    region: config.awsRegion,
  });

  // Amplify v6 configuration format - region must be inside Cognito object
  const amplifyConfig = {
    Auth: {
      Cognito: {
        userPoolId: config.cognitoUserPoolId,
        userPoolClientId: config.cognitoClientId,
        region: config.awsRegion,
        loginWith: {
          email: true,
        },
      },
    },
  };

  try {
    Amplify.configure(amplifyConfig);
    console.log('✅ Amplify configured successfully');
  } catch (error) {
    console.error('❌ Failed to configure Amplify:', error);
    throw error;
  }
}
